import UIDs from "../../../UIDs";

const uid = UIDs.screens.schoolSelection;

const ActionTypes = {
    LOAD_SCHOOLS_ASYNC: `${uid}.loadSchoolsAsync`,
    LOAD_SCHOOLS_SUCCESS: `${uid}.loadSchoolsSuccess`,
    LOAD_SCHOOLS_FAILURE: `${uid}.loadSchoolsFailure`,
    SEARCH_SCHOOLS: `${uid}.searchSchools`,
    SELECT_SCHOOL: `${uid}.selectSchool`,
};

export { ActionTypes };
